import { useMemo } from "react";
import { Pageable } from "../../../services/pageable";
import { getFields, validationFields } from "../../common/models/fields";

export namespace VaultsDTO {
  export namespace Requests {
    export namespace Create {
      export interface T {
        friendlyName: string;
      }
      export const useFields = () => {
        const name = validationFields.friendlyName.useName();
        const schema = validationFields.friendlyName.useSchema();
        return useMemo(
          () =>
            getFields({
              friendlyName: {
                name,
                schema,
              },
            }),
          [name, schema]
        );
      };
      export const defaults: T = {
        friendlyName: "",
      };
    }
  }

  export namespace Responses {
    export namespace GetSingleVault {
      export interface T {
        createdDate: string | null;
        friendlyName: string;
        id: string;
        numberOfEntries: number;
      }
    }

    export namespace GetAllVaults {
      export interface T {
        content: GetSingleVault.T[];
        pageable: Pageable.Response.T;
      }

      export const useFields = () => {
        const friendlyNameSchema = validationFields.friendlyName.useSchema();
        const createdDateSchema = validationFields.createdDate.useSchema();
        const numberOfEntriesSchema = validationFields.numberOfEntries.useSchema();
        const idSchema = validationFields.id.useSchema();

        const friendlyName = {
          name: validationFields.friendlyName.useName(),
          schema: friendlyNameSchema,
        };
        const createdDate = {
          name: validationFields.createdDate.useName(),
          schema: createdDateSchema,
        };
        const numberOfEntries = {
          name: validationFields.numberOfEntries.useName(),
          schema: numberOfEntriesSchema,
        };
        const id = {
          name: validationFields.id.useName(),
          schema: idSchema,
        };

        return useMemo(
          () =>
            getFields({
              friendlyName,
              createdDate,
              numberOfEntries,
              id,
            }),
          [
            friendlyName.name,
            friendlyName.schema,
            createdDate.name,
            createdDate.schema,
            numberOfEntries.name,
            numberOfEntries.schema,
            id.name,
            id.schema,
          ]
        );
      };

      export const defaults: T = {
        content: [],
        pageable: Pageable.Response.defaults,
      };
    }

    export namespace CreateVault {
      export interface T {
        id: string;
      }
      export const useFields = () => {
        const name = validationFields.id.useName();
        const schema = validationFields.id.useSchema();
        return useMemo(
          () =>
            getFields({
              id: {
                name,
                schema,
              },
            }),
          [name, schema]
        );
      };
    }

    export namespace GetSingleEntry {
      export interface T {
        id: string | null;
        createdDate: Date | null;
        expiresOn: Date | null;
        type: string | null;
      }
    }

    export namespace GetAllEntries {
      export interface T {
        content: GetSingleEntry.T[];
        pageable: Pageable.Response.T;
      }

      export const defaults: T = {
        content: [],
        pageable: Pageable.Response.defaults,
      };
    }
  }
}
